import { Component, Inject, OnInit, ViewChild } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { select, Store } from '@ngrx/store'
import {
  Rental,
  SelectableRow,
  selectRentalSubUnits,
  untilDestroy,
  isEmptyTable,
  selectRentalById,
} from '@tokeet-frontend/tv3-platform'
import { MatPaginator } from '@angular/material/paginator'
import { MatSort } from '@angular/material/sort'
import { SyncMainUnitDataHelperService } from './sync-main-unit-data-helper.service'
import { SyncMainUnitData } from './sync-rental-data'

@Component({
  selector: 'app-sync-main-unit-data-dialog',
  templateUrl: './sync-main-unit-data-dialog.component.html',
  styleUrls: ['./sync-main-unit-data-dialog.component.scss'],
  host: {
    class: 'modal-content',
  },
})
export class SyncMainUnitDataDialogComponent extends SelectableRow<Rental> implements OnInit {
  @ViewChild('paginator') set paginator(t: MatPaginator) {
    this.dataSource.paginator = t
  }
  get paginator() {
    return this.dataSource.paginator
  }

  @ViewChild(MatSort) set sort(t: MatSort) {
    if (t && !this.dataSource.sort) {
      this.dataSource.sort = t
    }
  }
  displayedColumns = ['select', 'name']
  isEmptyTable$ = isEmptyTable(this.dataSource)

  mainRental: Rental

  constructor(
    public dialogRef: MatDialogRef<SyncMainUnitDataDialogComponent>,
    private store: Store<any>,
    private syncMainUnitDataHelper: SyncMainUnitDataHelperService,
    @Inject(MAT_DIALOG_DATA) public data: { mainUnitId: string; data: SyncMainUnitData }
  ) {
    super()
  }

  ngOnInit(): void {
    this.store.pipe(select(selectRentalSubUnits(this.data.mainUnitId)), untilDestroy(this)).subscribe((rentals) => {
      this.dataSource.data = rentals
      this.masterToggle(false)
    })

    this.store.pipe(select(selectRentalById(this.data.mainUnitId)), untilDestroy(this)).subscribe((rental) => {
      this.mainRental = rental
    })
  }

  close() {
    this.dialogRef.close()
  }

  onSave() {
    const subunits = this.getSelected()

    this.syncMainUnitDataHelper.save(subunits, this.mainRental, this.data.data)

    this.close()
  }
}
